import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('DocumentTypeService', DocumentTypeService);

  DocumentTypeService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    'UtilService',
    'SessionService',
    'TranslationModalService',
    'WindowModalService',
    'ModalWindowConfirmService',
  ];

  function DocumentTypeService(
    RestResource,
    config,
    $translate,
    UtilService,
    SessionService,
    TranslationModalService,
    WindowModalService,
    ModalWindowConfirmService
  ) {
    let utils = new UtilService(this);

    let apiUrl = environment.apiEndpoint + 'document_types';

    let service = {
      getFilterCriteria: getFilterCriteria,
      getDocumentTypes: getDocumentTypes,
      getDocumentType: getDocumentType,
      saveDocumentType: saveDocumentType,
      openDocumentTypeDetailModal: openDocumentTypeDetailModal,
      openDocumentTypeTranslations: openDocumentTypeTranslations,
      changeDocumentTypeStatus: changeDocumentTypeStatus,
      changeDocumentTypeDefault: changeDocumentTypeDefault,
      deleteDocumentType: deleteDocumentType,

      updatePredefinedDocumentTypes: updatePredefinedDocumentTypes,
      groupDocumentTypesByTransactionType: groupDocumentTypesByTransactionType,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      const filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function getDocumentTypes(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getDocumentType(id, language, translate) {
      var params = { lang: null, get: null };

      if (language) {
        params.lang = language;
      }

      if (translate) {
        params.get = 'translate';
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveDocumentType(documentType, language) {
      let method;
      let url = apiUrl;

      if (!documentType.id) {
        // create
        method = 'post';
        documentType.company_id = SessionService.getSelectedAccountCompany().id;
      } else {
        method = 'put';
        url += '/' + documentType.id;
      }

      let lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;

      function success(response) {
        let msg = !documentType.id ? 'DOCUMENT_TYPE_ADDED' : 'DOCUMENT_TYPE_MODIFIED';
        utils._successMsg($translate.instant(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(
        method,
        url,
        { document_type: documentType, lang: lang },
        success,
        failure
      );
    }

    function openDocumentTypeDetailModal(
      documentType,
      defaultLanguage,
      additionalLanguages,
      mode,
      successCallback
    ) {
      let templateUrl = './app/ajs/document-types/modals/document-type-detail-modal.html';

      let originalItem = angular.copy(documentType);

      let modalParams = {
        title: 'DOCUMENT_TYPE_DETAILS',
        item: originalItem,
        mode: mode,
        defaultLanguage: defaultLanguage,
        additionalLanguages: additionalLanguages,
        preventModalClose: true,
      };

      // if (!documentType.id){
      //     modalParams.closeOnSave = false; // Do not close modal after create
      // }

      // onSavedItem in modal service
      let confirmCallback = function (response) {
        if (documentType.id) {
          // Edit
          documentType.name = response.name;
          documentType.numbering_type = response.numbering_type;
          documentType.prefix = response.prefix;
          documentType.length = response.length;
          documentType.starting_number = response.starting_number;
          documentType.transaction_type = response.transaction_type;
          documentType.allows_repeated = response.allows_repeated;
          documentType.allows_past_days = response.allows_past_days;
          documentType.allows_future_days = response.allows_future_days;
          documentType.ticket_printing = response.ticket_printing;
          // documentType.client_required    = response.client_required;

          return utils.itemListChanged(response.id);
        }

        return successCallback(response);
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }

    function openDocumentTypeTranslations(documentType, additionalLanguages) {
      let template = './app/ajs/document-types/modals/document-type-detail-translation.html';

      let modalParams = {
        title: documentType.name,
        item: documentType,
        additionalLanguages: additionalLanguages,
      };

      let initializeCallback = function (itemId, language) {
        return getDocumentType(itemId, language, 'translate').then(function (data) {
          return data;
        });
      };

      let confirmCallback = function (documentType, language) {
        return saveDocumentType(documentType, language).then(function (data) {
          if (!data.status) {
            return data.response;
          }

          return false;
        });
      };

      TranslationModalService.open(template, modalParams, initializeCallback, confirmCallback);
    }

    function changeDocumentTypeStatus(documentType) {
      utils.changeItemStatus(apiUrl + '/' + documentType.id, documentType);
    }

    function changeDocumentTypeDefault(documentType, successCallback) {
      let url = apiUrl + '/' + documentType.id;

      documentType.is_default = true;

      let params = {
        document_type: {
          is_default: true,
        },
        set_default: true,
      };

      function success() {
        let msg = $translate.instant('DEFAULT_DOCUMENT_TYPE_CHANGED');
        utils._successMsg(msg);

        return successCallback();
      }
      function failure() {}

      return RestResource.request('put', url, params, success, failure);
    }

    function deleteDocumentType(documentType, successCallback) {
      if (documentType.used_in_transactions) {
        let modalParams = {
          mode: 'danger',
          title: 'CANNOT_DELETE_DOCUMENT_TYPE',
          body: 'CANNOT_DELETE_DOCUMENT_TYPE_WITH_TRANSACTIONS',
        };

        ModalWindowConfirmService.open(modalParams);
        return;
      }

      let params = {
        title: 'DELETE_DOCUMENT_TYPE',
        reason: 'DELETE_ITEM_REASON',
        successMsg: 'DOCUMENT_TYPE_DELETED',
      };

      utils.deleteItem(apiUrl + '/' + documentType.id, successCallback, params);
    }

    function updatePredefinedDocumentTypes(atv_enabled, company_id) {
      let method = 'post';
      let url = apiUrl + '/update_predefined_types';

      function success(response) {
        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(
        method,
        url,
        { skip_check_role: true, atv_enabled: atv_enabled, company_id: company_id },
        success,
        failure
      );
    }

    function groupDocumentTypesByTransactionType(documentTypes) {
      let transactionTypes = config.TRANSACTION_TYPES;

      let array = [];
      transactionTypes.forEach(function (transactionType) {
        let obj = {
          name: transactionType.name,
          value: transactionType.value,
          icon: transactionType.icon,
          docTypes: [],
        };

        for (let i = 0; i < documentTypes.length; i++) {
          if (transactionType.value === documentTypes[i].transaction_type) {
            obj.docTypes.push(documentTypes[i]);
            break;
          }
        }

        array.push(obj);
      });

      return array;
    }
  }
})();
